<template>
        <!--<slide-x-left-transition :duration="index < 5 ? 400+(index*100) : 400" :delay="index < 5 ? 200+(index*100) : 200">-->
        <!--</slide-x-left-transition>-->
    <ion-card mode="ios" class="item-news ion-activatable">
        <router-link :to="route" style="display: block;">
            <ion-badge style="position: absolute; right: 15px; top: 15px;">{{ badge }}</ion-badge>
            <!--<ion-skeleton-text v-if="!isLoaded" animated style="width: 100%; height: 200px; margin: 0"></ion-skeleton-text>-->
            <img :src="image" style="width: 100%; height: auto"/>
            <ion-card-header>
                <h6 class="text-up m-0">{{ date }}</h6>
                <h3 style="margin: 0; color: #000000">{{ title }}</h3>
            </ion-card-header>
        </router-link>
        <ion-card-content>
            <!--<p>{{ subtitle }}</p>-->
            <ion-button mode="ios" fill="outline" size="small" @click="openModal(title, subtitle)">Czytaj więcej</ion-button>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import Modal from '@/components/Modal.vue';

    export default {
        name: 'ItemNews',
        props: ['index', 'route', 'slug', 'badge', 'title', 'subtitle', 'image', 'date'],
//        data() {
//            return {
//                isLoaded: false
//            }
//        },
//        mounted() {
//            this.show = true;
//        },
        methods: {
//            onImgLoad(e){
//                this.isLoaded = true
//            },
            openModal(title, description){
                return this.$ionic.modalController.create({
                    component: Modal,
                    mode: 'ios',
                    componentProps: {
                        propsData: {
                            title: this.date,
                            html: '<h3>'+title+'</h3><p>'+description+'</p>',
                            ctaLabel: 'Przejdź do artykułu',
                            route: this.route,
                        },
                    },
                }).then(m => m.present())
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-header{
        --background: #ffffff;
    }
    ion-card-content{
        padding: 0 20px 20px 20px;
    }
</style>